export function AskHeader() {
  return (
    <div className="w-full flex justify-center items-center">
      <img src="/babask-logo.png" alt="Logo" className="w-[100px]" />
    </div>
  );
}

export function EmptyAskHeader() {
  return (
    <div className="w-full flex justify-center items-center">
      <img src="/babask-logo.png" alt="Logo" className="w-[220px]" />
    </div>
  );
}
